export const ROLE = {
  ADMIN: "Admin",
  GUEST: "Huesped",
  RECEPCIONIST: "Recepcionista",
};
